import { useEffect, useRef } from 'react'
import { Stomp } from '@stomp/stompjs'
import { getWebSocketUrl } from '../../../../../../_metronic/helpers/webSocketHelper'
import { useAuth } from '../../../../auth'
import { TriagemEvento } from '../../../triagem/core/_models'

/**
 * Assina o tópico de triagem da empresa (`/topic/triagem/{idEmpresa}`) e entrega os eventos ao
 * chamador.
 *
 * O payload traz só ids, origem e cor — nenhum dado do paciente. Quem recebe o evento **recarrega
 * pelo endpoint autorizado**; nada do que chega aqui é exibido direto, porque o tópico hoje é
 * assinável por qualquer autenticado.
 */
export const useTriagemEventos = (
  idEmpresa: number | undefined,
  onEvento: (evento: TriagemEvento) => void
) => {
  const { auth } = useAuth()
  const accessToken = auth?.accessToken
  const callbackRef = useRef(onEvento)
  callbackRef.current = onEvento

  useEffect(() => {
    if (!idEmpresa || !accessToken) return

    const stompClient = Stomp.client(getWebSocketUrl('/socket/atendimento'))
    stompClient.debug = () => undefined

    const onConnect = () => {
      stompClient.subscribe(`/topic/triagem/${idEmpresa}`, (mensagem) => {
        try {
          callbackRef.current(JSON.parse(mensagem.body) as TriagemEvento)
        } catch {
          // payload inesperado: ignorar é melhor do que derrubar o card
        }
      })
    }

    stompClient.connect({ Authorization: `Bearer ${accessToken}` }, onConnect, () => undefined)

    return () => {
      try {
        stompClient.disconnect()
      } catch {
        //
      }
    }
  }, [idEmpresa, accessToken])
}
